import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';

import { AssessmentBadgeComponent } from './components/assessment-badge/assessment-badge.component';
import {
  AssessmentButtonsComponent
} from './components/assessment-buttons/assessment-buttons.component';
import {
  AssessmentCircleComponent
} from './components/assessment-circle/assessment-circle.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AssessmentBadgeComponent,
    AssessmentCircleComponent,
    AssessmentButtonsComponent
  ],
  providers: [],
  exports: [
    AssessmentBadgeComponent,
    AssessmentCircleComponent,
    AssessmentButtonsComponent
  ]
})
export class AssessmentSharedModule { }
